export default function nearest(fraction, n) {
    return fraction * Math.round(n / fraction);
}
